"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Delay = void 0;
const react_1 = require("react");
const DEFAULT_DELAY = 15; // delay in seconds
const Delay = ({ children, secondsToWaitBeforeShow = DEFAULT_DELAY }) => {
    const [isShown, setIsShown] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const timer = setTimeout(() => {
            setIsShown(true);
        }, secondsToWaitBeforeShow * 1000);
        return () => clearTimeout(timer);
    }, [secondsToWaitBeforeShow]);
    return isShown ? children : null;
};
exports.Delay = Delay;
//# sourceMappingURL=Delay.js.map